import React, { useState } from "react";
import "./MonthlyReport.css";
import { MonthlyReportForm } from "../../components/monthlyreportform/MonthlyReportForm";
import { ReportsTable } from "../../components/reportstable/ReportsTable";
export const MonthlyReport = () => {
  const [reportReload, setReportReload] = useState(false);

  return (
    <div className="monthly-report-container">
      <MonthlyReportForm setReportReload={setReportReload} />
      <ReportsTable
        reportReload={reportReload}
        setReportReload={setReportReload}
      />
    </div>
  );
};
